import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { environment } from '../environments/environment';
import { ActAsService } from './services/act-as.service';

const DEVICE_KEY = 'deviceId';

/** A stable per-browser-install identifier (org plan, round 5): the
 *  backend persists it ONLY for org-staff accounts, as their access
 *  log's device column. A browser has no hardware id, so a minted UUID
 *  in localStorage is the honest equivalent. */
function deviceId(): string {
  try {
    let id = localStorage.getItem(DEVICE_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(DEVICE_KEY, id);
    }
    return id;
  } catch {
    return 'browser-unknown';
  }
}

/** Functional on purpose, registered AFTER the DI interceptors: the
 *  auth interceptor's 401-retry rebuilds its request from the original,
 *  and only a later interceptor decorates both the first try and the
 *  retry (the gap the phase-2 review of auth.interceptor.ts flagged). */
export const orgHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }
  const headers: Record<string, string> = { 'X-Device-Id': deviceId() };
  const actAs = inject(ActAsService).org();
  if (actAs) {
    // Super-admin act-as (anyone else sending it gets a 403, by design).
    headers['X-Org-Context'] = String(actAs.id);
  }
  return next(req.clone({ setHeaders: headers }));
};
